var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2132 16.4933H27.4665C27.3599 22.72 26.1332 23.7467 22.3065 26.0133C21.8665 26.28 21.7199 26.84 21.9865 27.2933C22.2532 27.7333 22.8132 27.88 23.2665 27.6133C27.7732 24.9467 29.3465 23.32 29.3465 15.56V8.37333C29.3465 6.09333 27.4932 4.25333 25.2265 4.25333H21.2265C18.8799 4.25333 17.1065 6.02667 17.1065 8.37333V12.3733C17.0932 14.72 18.8665 16.4933 21.2132 16.4933Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7865 16.4933H13.0398C12.9332 22.72 11.7065 23.7467 7.87984 26.0133C7.43984 26.28 7.29317 26.84 7.55984 27.2933C7.8265 27.7333 8.3865 27.88 8.83984 27.6133C13.3465 24.9467 14.9198 23.32 14.9198 15.56V8.37333C14.9198 6.09333 13.0665 4.25333 10.7998 4.25333H6.79984C4.43984 4.25333 2.6665 6.02667 2.6665 8.37333V12.3733C2.6665 14.72 4.43984 16.4933 6.7865 16.4933Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteDown);
export default __webpack_public_path__ + "static/media/quote-down.ccf39e6176c432a7f142049b491a9e9f.svg";
export { ForwardRef as ReactComponent };